import { ImageOff } from "lucide-react";

export const AuditThumb = ({ src }) =>
    src ? (
        <img src={src} alt="" loading="lazy" className="w-10 h-10 object-contain bg-white border border-slate-200" />
    ) : (
        <div className="w-10 h-10 bg-slate-100 flex items-center justify-center"><ImageOff className="w-4 h-4 text-slate-400" /></div>
    );
